export const DOWNLOAD_FAILURE_MESSAGE = 'Downloading the report failed. Please retry from the link in your e-mail, or contact IPC helpdesk (helpdesk@ipc.be) if the problem persists.';

export const DOWNLOAD_ALREADY_IN_PROGRESS_MESSAGE = 'This report is already being downloaded. Please wait for the current download to finish before trying again.';

export const DOWNLOAD_CAPACITY_REACHED_MESSAGE = 'The server is busy processing other report downloads. Please wait 30 seconds, then retry from the link in your e-mail.';

export function getDownloadFailureMessage(error) {
  const businessError = error?.response?.data?.BusinessError;
  const isDownloadBusy = error?.response?.status === 429
    && businessError?.messageKey === 'error.report.download.busy';

  if (!isDownloadBusy) return DOWNLOAD_FAILURE_MESSAGE;

  switch (businessError.arguments?.[0]) {
    case 'duplicate':
      return DOWNLOAD_ALREADY_IN_PROGRESS_MESSAGE;
    case 'capacity':
      return DOWNLOAD_CAPACITY_REACHED_MESSAGE;
    default:
      return DOWNLOAD_FAILURE_MESSAGE;
  }
}
